import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useShowBlock() {
  const queryClient = useQueryClient();

  const showBlock = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.block.show, { id }),
      config: {
        method: "PATCH",
      },
    };
    return client(request);
  };

  const { data, mutateAsync, ...rest } = useMutation<Response<null>, Error, string>(showBlock, {
    onSettled: (data, error, id) => {
      queryClient.invalidateQueries([ENDPOINTS.block.one, id]);
      queryClient.invalidateQueries([ENDPOINTS.block.all]);
    },
  });

  return { data, mutateAsync, ...rest };
}
